import { IAlarmRow, IAlarmRowsProp } from "../interfaces/IAlarm";
import { AlarmOrderBy, SortDTO } from "../utils/type.util";

export function createAlarmsState(): IAlarmRowsProp {
    return {
      content: [] as IAlarmRow[],
      filters: {
        orderBy: AlarmOrderBy.name,
        orderDir: SortDTO.ASC,
      },
      size: 10,
      number: 1,
      totalPages: 0,
      totalElements: 0,
    } as IAlarmRowsProp;
}
